<info-modal [title]="title" (onOk)="ok()">
	<div class="form-group">
		<label>Список сайтов (технических доменов) в один столбец</label>
		<textarea class="form-control" rows="3" [(ngModel)]="domains"></textarea>
		<div style="margin-top: 15px;"><ngb-alert type="danger" *ngIf="alertMessage != ''" (close)="alertMessage = ''">{{alertMessage}}</ngb-alert></div>
	</div>

	<div class="row">
		<div class="col">
			<button class="btn btn-primary" (click)="checkIt()" [disabled]="inProgress">Проверить</button>
		</div>
		<div class="col">
			<loading [isLoad]="inProgress"></loading>
		</div>
	</div>	
	
	<br />
	
	<table class="table table-sm" *ngIf="sites.length > 0">
		<thead>
		<tr>
			<th scope="col">Сайт</th>
			<th scope="col">Divly</th>
		</tr>
		</thead>
		<tbody>
		<tr *ngFor="let site of sites">
			<td>{{site.url}}</td>
			<td>{{site.status}}</td>
		</tr>
		</tbody>
	</table>
</info-modal>
